import {
  LoadMyCoursesAsync,
  LoadMyOrdersAsync,
  ShowMyCartSummaryAsync,
} from './aka.js';
import { getUrlParameter } from './shared/utils';
export async function mainakaprofile() {
  // const id = getUrlParameter('id').toString();
  // console.log('akaprofile '+id);
  await LoadMyCoursesAsync();
  await LoadMyOrdersAsync();
  await ShowMyCartSummaryAsync();
}
